import React, {useEffect} from 'react'
import './wowbii.css'
import Androidscreenshoot from '../images/Wowbii/Androidscreenshoot.png'
import Artboard1 from '../images/Wowbii/Artboard1.png'
import Artboard2 from '../images/Wowbii/Artboard2.png'
import Artboard3 from '../images/Wowbii/Artboard3.png'
import Artboard4 from '../images/Wowbii/Artboard4.png'
import Artboard5 from '../images/Wowbii/Artboard5.png'
import Artboard6 from '../images/Wowbii/Artboard6.png'
import Artboard7 from '../images/Wowbii/Artboard7.png'

import Artboard9 from '../images/Wowbii/Artboard9.png'
import Artboard10 from '../images/Wowbii/Artboard10.png'

import Footer from '../Component/footer'

function Wowbii() {
    useEffect(() => {
        window.scroll(0, 0);
        document.body.scrollTop = 0;
    }, []);
    return (
        <div>
       
        <div className="imagevh" id="imageAndroidscreenshoot"><img src={Androidscreenshoot} height="" width="100%" alt=""/></div>
        
        <div className="project-details-Wowbii">
        <div className="client-role-Wowbii">
            <h4 className="client-project-Wowbii">CLIENT</h4>
            <h2 className="portfolio-heading-Wowbii1"> Wowbii</h2>
            <h4 className="role-Wowbii">
            ROLE
            </h4>
            <h2 className="portfolio-role-Wowbii2">Social Media Content Creator</h2>
           </div>
            <h4 className="client-details-Wowbii"> DETAILS
            </h4>
            <p className="client-details-Wowbii-p">
            WOWBii Interactive is an original equipment manufacturer offering 
            technology-enhanced solutions, interactive telepresence and digital signage solutions.
            </p>

            <p className="client-details-Wowbii-p2">
            As an African brand focused on providing simple yet durable products, 
            WOWBii aims to be the preferred interactive solutions provider on the continent.

            </p>
         </div>


         <div className="imagevh" id="artboard"><img src={Artboard1} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard2} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard3} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard4} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard5} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard6} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard7} height="auto" width="100%" alt=""/></div>
       
         <div className="imagevh" id="artboard"><img src={Artboard9} height="auto" width="100%" alt=""/></div>
         <div className="imagevh" id="artboard"><img src={Artboard10} height="auto" width="100%" alt=""/></div>
         
     <div className="imagevh" id="artboard" ><Footer /></div> 

        </div>
        
    )
}


export default Wowbii
